import { render, staticRenderFns } from "./cardDetailDialog.vue?vue&type=template&id=97dd8106&scoped=true&"
import script from "./cardDetailDialog.vue?vue&type=script&lang=js&"
export * from "./cardDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./cardDetailDialog.vue?vue&type=style&index=0&id=97dd8106&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dd8106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97dd8106')) {
      api.createRecord('97dd8106', component.options)
    } else {
      api.reload('97dd8106', component.options)
    }
    module.hot.accept("./cardDetailDialog.vue?vue&type=template&id=97dd8106&scoped=true&", function () {
      api.rerender('97dd8106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/internal-task/cardDetailDialog.vue"
export default component.exports